<script lang="ts">
  import Logo from '$components/Logos/Logo.svelte';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { cx } from '@emotion/css';
  import { ResponsiveVars } from '@twist/core';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';

  $: globalNavEnabled = flagValue(FEATURE_FLAGS.GLOBAL_NAV);

  const responsiveVars = new ResponsiveVars()
    .addFluid('logo-size', toFluidVarInput(30, 30))
    .addFluid('logo-padding', toFluidVarInput(5, 5))
    .toCSS();
</script>

<div class={cx('logo', responsiveVars, { 'global-nav-enabled': globalNavEnabled })}>
  <div class="logo__inner">
    <Logo />
  </div>
</div>

<style lang="scss">
  .logo {
    padding: var(--logo-padding);

    &:hover,
    &:focus-within {
      background-color: var(--twist-color-gray-100);
      border-radius: 1000px;

      & :global(*) {
        outline: none;
      }
    }

    &:active {
      opacity: 0.6;
    }

    .logo__inner {
      width: var(--logo-size);
      height: var(--logo-size);
    }
  }

  .logo.global-nav-enabled {
    &:hover,
    &:focus-within {
      background: none;
      outline: 1px solid var(--twist-color-gray-100);
    }
  }
</style>
